<template>
    <admin-breadcrumbs>
        <li class="breadcrumb-item active">
            Users
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Users
        </div>

        <div class="card-body">
            <users-table endpoint="/admin/api/users" />
        </div>

    </div>
</template>

<script>
import UsersTable from "../../../admin/UsersTable.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
  name: "Users",

  components: {
      AdminBreadcrumbs,
      UsersTable,
  },
};
</script>
